import React from 'react';
import TableCheckbox from '../../Forms/Input/TableCheckbox';
import BasicPagination from '../../DataTable/BasicPagination';
import { InitialStockAdminRow } from '../../../types/inventory/initialStockAdmin/InitialStockAdminTypes';

interface Props {
  rows: InitialStockAdminRow[];
  isLoading: boolean;
  isSelected: (row: InitialStockAdminRow) => boolean;
  onToggle: (row: InitialStockAdminRow) => void;

  paginator: any;
  page: number;
  size: number;
  onPageChange: (page: number) => void;
  onSizeChange: (size: number) => void;
}

const InitialStockAdminTable: React.FC<Props> = ({
  rows,
  isLoading,
  isSelected,
  onToggle,
  paginator,
  page,
  size,
  onPageChange,
  onSizeChange,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full table-auto">
        <thead>
          <tr className="bg-gray-2 dark:bg-meta-4 text-left">
            <th className="w-12 px-4 py-3"></th>
            <th className="px-4 py-3 font-medium">Producto</th>
            <th className="px-4 py-3 font-medium">Categoría</th>
            <th className="px-4 py-3 font-medium">Sucursal</th>
            <th className="px-4 py-3 text-right font-medium">Stock Actual</th>
            <th className="px-4 py-3 text-right font-medium">Costo Promedio</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan={6} className="px-4 py-6 text-center text-body dark:text-bodydark2">
                Cargando...
              </td>
            </tr>
          )}

          {!isLoading && rows.length === 0 && (
            <tr>
              <td colSpan={6} className="px-4 py-6 text-center text-body dark:text-bodydark2">
                No hay productos para estos filtros.
              </td>
            </tr>
          )}

          {!isLoading &&
            rows.map((row) => {
              const negative = row.stockQuantity < 0;
              return (
                <tr
                  key={`${row.productId}-${row.branchId}`}
                  className="border-b border-stroke dark:border-strokedark"
                >
                  <td className="px-4 py-3">
                    <TableCheckbox checked={isSelected(row)} onChange={() => onToggle(row)} />
                  </td>
                  <td className="px-4 py-3">
                    <div className="font-mono text-xs text-gray-500 dark:text-gray-400">
                      {row.productCode}
                    </div>
                    <div className="font-medium text-black dark:text-white">{row.productName}</div>
                  </td>
                  <td className="px-4 py-3 text-sm">{row.categoryName ?? '—'}</td>
                  <td className="px-4 py-3 text-sm">{row.branchName}</td>
                  <td
                    className={`px-4 py-3 text-right font-semibold ${
                      negative ? 'text-danger' : 'text-black dark:text-white'
                    }`}
                  >
                    {row.stockQuantity} {row.unitCode ?? ''}
                  </td>
                  <td className="px-4 py-3 text-right">${row.averageCost.toFixed(4)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {paginator && (
        <div className="mt-4">
          <BasicPagination
            currentPage={page}
            totalPages={paginator.totalPages ?? 0}
            totalElements={paginator.totalElements}
            first={paginator.first}
            last={paginator.last}
            size={size}
            onPageChange={onPageChange}
            onSizeChange={onSizeChange}
          />
        </div>
      )}
    </div>
  );
};

export default InitialStockAdminTable;
